module.exports = __webpack_public_path__ + "amcharts/images/eraserIcon.svg";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=amcharts/images/[name].[ext]!./~/amstock3/amcharts/images/eraserIcon.svg
// module id = 264
// module chunks = 0